import axios from 'axios';
import {
    apiTransitionPersonalDetailsForm,
    calculatePersonalDetailsAmlWhitelistSuccess,
} from '../../../actions/ugMotorInsurance/personalDetails';
import { getAccessToken } from '../../../selectors/ugMotorInsurance/payments';
import { getQuoteForm } from '../../../selectors/ugMotorInsurance/quote';
import { getAgentForm } from '../../../selectors/ugMotorInsurance/travelAgentModal';

export const amlWhitelistCheckService = (store, next, action) => {
    (async () => {
        store.dispatch(apiTransitionPersonalDetailsForm.pending());
        try {
            const resp = await calculate(store.getState());

            store.dispatch(calculatePersonalDetailsAmlWhitelistSuccess(resp.data.message));
            store.dispatch(apiTransitionPersonalDetailsForm.success());
        } catch (e) {
            console.error(e);
            store.dispatch(apiTransitionPersonalDetailsForm.failure());
        }
    })();
    return next(action);
};

const amlWhitelistCheckServicePayload = (state) => {
    const quotation = getQuoteForm(state);
    const agent = getAgentForm(state);

    const amlWhitelistCalculationPayload = {
        firstName: quotation.firstName.value || '',
        surName: quotation.lastName.value || '',
        middleName: quotation.middleName.value || '',
        agentType: agent.intermediaryType.value || '',
        coverType: 'Motor Insurance',
    };

    return {
        ...amlWhitelistCalculationPayload,
    };
};

const calculate = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/ug-motor-insurance/aml-whitelist';

        return await axios.post(url, amlWhitelistCheckServicePayload(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
                Cookie: 'devEnvironment=ea-qa',
            },
        });
    } catch (e) {
        console.error(e);
        throw e;
    }
};
